module.exports = __webpack_public_path__ + "img/fi.b0b59ca1.svg";